import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';

export default class Button extends React.Component {

    static get propTypes() {

        return {
            onClick: PropTypes.func,
            children: PropTypes.any,
            type: PropTypes.string,
            style: PropTypes.string,
            className: PropTypes.string,
        };
    }

    static get styles() {

        return {
            SUCCESS_OUTLINE: style('button-success-outline'),
        };
    }

    render() {

        return (
            <button
                type={ this.props.type ?? 'button' }
                onClick={ (e) => this.handleClick(e) }
                className={ this.getStyledClasses() }
                { ...this.unusedProps }>
                { this.props.children }
            </button>
        );
    }

    getStyledClasses() {

        const classes = [];

        if (this.props.style == 'outline')
            classes.push('button-primary-outline');

        if (classes.length == 0)
            classes.push('button');

        return `${style(classes)} ${this.props.className ?? ''}`.trim();
    }

    /** private */ get unusedProps() {

        const usedKeys = Object.keys(Button.propTypes);

        return Object.fromEntries(Object.entries(this.props).map(([key, value]) => {

            if (!usedKeys.includes(key))
                return [key, value];

        }).filter((value) => value !== undefined));
    }

    handleClick(e) {

        if (this.props.onClick != undefined)
            this.props.onClick(e);
    }

}